import Api  from './Api'
import axios from 'axios'

class StaffApi extends Api {
    async searchByRole(role){
        const request = async () => await axios.get(this.generateAbsolutePath(`buscar/personal/${role}`));
            
        const { data } = await this.perform(request);

        return data;
    }
}

export default StaffApi;